import React, { useContext, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import './Navbar.css';

const Navbar = () => {
    const { user, logOut } = useContext(AuthContext);
    const navigate = useNavigate();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const displayName = [user?.firstName, user?.lastName].filter(Boolean).join(' ') || 'Profile';
    const firstName = user?.firstName || 'Profile';
    const initials = `${user?.firstName?.[0] || ''}${user?.lastName?.[0] || ''}`.toUpperCase() || 'U';

    const handleUploadClick = (event) => {
        event.preventDefault();
        if (!user) {
            navigate('/login');
        } else {
            navigate('/upload/step1');
        }
        closeDrawer();
    };

    const toggleDrawer = () => {
        setDrawerOpen(!drawerOpen);
    };

    const closeDrawer = () => {
        setDrawerOpen(false);
    };

    const handleBrowseClick = (event) => {
        event.preventDefault();
        navigate('/browse', { state: { resetAt: Date.now() } });
        closeDrawer();
    };

    const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <nav className="navbar">
            <div className="navbar-left">
                <Link to="/" className="navbar-logo">VetBill</Link>
                {!isMobile && (
                    <ul className="nav-list">
                        <li className="nav-item"><Link to="/browse" className="nav-link" onClick={handleBrowseClick}>Browse Vet Bills</Link></li>
                        <li className="nav-item"><Link to="/upload/step1" className="nav-link" onClick={handleUploadClick}>Upload a Bill</Link></li>
                        <li className="nav-item"><Link to="/advice" className="nav-link">Advice</Link></li>
                        {user?.role === 'admin' && (
                            <li className="nav-item"><Link to="/admin" className="nav-link">Admin</Link></li>
                        )}
                    </ul>
                )}
            </div>
            {!isMobile && (
                <div className="navbar-right">
                    {user ? (
                        <div className="profile-dropdown">
                            <button className="profile-trigger" type="button" aria-haspopup="true">
                                <span className="profile-avatar">{initials}</span>
                                <span className="profile-trigger-text">{firstName}</span>
                                <span className="profile-caret" aria-hidden="true">v</span>
                            </button>
                            <div className="dropdown-content">
                                <div className="dropdown-user-summary">
                                    <strong>{displayName}</strong>
                                    <span>{user.email}</span>
                                </div>
                                <Link to="/dashboard" className="dropdown-link">My Vet Bills</Link>
                                <Link to="/profile" className="dropdown-link">Profile</Link>
                                <Link to="/account" className="dropdown-link">Account Security</Link>
                                <button onClick={logOut} className="dropdown-link dropdown-link-danger">Log out</button>
                            </div>
                        </div>
                    ) : (
                        <ul className="nav-list">
                            <li className="nav-item"><Link to="/login" className="nav-link">Login</Link></li>
                            <li className="nav-item"><Link to="/signup" className="nav-link">Signup</Link></li>
                        </ul>
                    )}
                </div>
            )}
            {isMobile && (
                <>
                    <div className="menu-icon" onClick={toggleDrawer}>
                        &#9776;
                    </div>
                    <div className={`nav-drawer ${drawerOpen ? 'open' : ''}`}>
                        <ul className="nav-list">
                            <li className="nav-item"><Link to="/browse" className="nav-link" onClick={handleBrowseClick}>Browse Vet Bills</Link></li>
                            <li className="nav-item"><Link to="/upload/step1" className="nav-link" onClick={handleUploadClick}>Upload a Bill</Link></li>
                            <li className="nav-item"><Link to="/advice" className="nav-link" onClick={closeDrawer}>Pricing and Advice</Link></li>
                            {user?.role === 'admin' && (
                                <li className="nav-item"><Link to="/admin" className="nav-link" onClick={closeDrawer}>Admin</Link></li>
                            )}
                            {user ? (
                                <>
                                    <li className="nav-item"><Link to="/dashboard" className="nav-link" onClick={closeDrawer}>My Vet Bills</Link></li>
                                    <li className="nav-item"><Link to="/profile" className="nav-link" onClick={closeDrawer}>My Profile</Link></li>
                                    <li className="nav-item"><Link to="/account" className="nav-link" onClick={closeDrawer}>Account Security</Link></li>
                                    <li className="nav-item"><button onClick={() => { logOut(); closeDrawer(); }} className="nav-link">Log Out</button></li>
                                </>
                            ) : (
                                <>
                                    <li className="nav-item"><Link to="/login" className="nav-link" onClick={closeDrawer}>Login</Link></li>
                                    <li className="nav-item"><Link to="/signup" className="nav-link" onClick={closeDrawer}>Signup</Link></li>
                                </>
                            )}
                        </ul>
                    </div>
                    <div className={`drawer-overlay ${drawerOpen ? 'open' : ''}`} onClick={closeDrawer}></div>
                </>
            )}
        </nav>
    );
};

export default Navbar;
